module.exports = __webpack_public_path__ + "img/jdError.5063927b.png";